import { createFileRoute } from '@tanstack/react-router'
import { TicketType } from '@/components/settings-route/ticket/type-ticket/index.jsx'

export const Route = createFileRoute('/_auth/settings/tickets/ticket-type')({
  component: TicketType,
})
